import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { SurveyValueExcelFailure } from '../../types/entity.types';
import { UploadSurveyRequest } from './survey.types';

import { requestUploadSurvey } from './survey.actions';

export const useSurveyApi = () => {
  const dispatch = useDispatch();

  const uploadSurvey = useCallback(
    (requestData: UploadSurveyRequest, onError?: (failures: SurveyValueExcelFailure[]) => void) => {
      dispatch(requestUploadSurvey({ requestData, onError }));
    },
    [dispatch]
  );

  return { uploadSurvey };
};
